// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__3JKL4","container":"SectionHeader_container__Mk5aO","header__heading":"SectionHeader_header__heading__Zr3tY"};